import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const DiscoverProducts = () => {
  const productCategories = [
    {
      title: "Dry Skin",
      description: "Deep hydration and barrier-repairing formulas to soothe and nourish.",
      image: "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      title: "Oily Skin",
      description: "Balancing botanicals that calm excess oil without stripping your skin.",
      image: "https://images.unsplash.com/photo-1612817288484-6f916006741a?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      title: "Acne-Prone",
      description: "Clarifying ingredients to reduce breakouts, inflammation & redness.",
      image: "https://images.unsplash.com/photo-1620916297397-a4a5402a3c6c?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
  ];

  return (
    <section className="py-20 px-4 bg-[#fef8f5]">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f]">
          Discover Our Products
        </h2>
        <p className="mt-4 text-[#7a6e5f] opacity-80 max-w-xl mx-auto">
          From dry to oily to acne-prone — SuprSkin adapts to you, not the other way around.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto mb-12">
        {productCategories.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl overflow-hidden shadow-md"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-64 object-cover"
            />
            <div className="p-6 text-left text-[#7a6e5f]">
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-sm opacity-80">{item.description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="text-center">
        <Link
          to="/products"
          className="inline-block bg-[#809080] text-white px-8 py-3 rounded-md hover:bg-[#6d7d6d] transition-colors font-medium"
        >
          Explore All Products
        </Link>
      </div>
    </section>
  );
};

export default DiscoverProducts;

